import { PopoverProps } from "react-bootstrap";
import { ContactsLabel, TimingLabel } from "../../shared/enums/labels.enums";

export interface IToolTipProps extends PopoverProps {
  packageStatus?: string;
  phaseName?: string;
  timingLabel?: TimingLabel;
  contactsLabel?: ContactsLabel;
}

export const DefaultToolTipProps: IToolTipProps = {
  packageStatus: undefined,
  phaseName: undefined,
  timingLabel: undefined,
  contactsLabel: undefined,
};
